// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import React from 'react';
import { Card, Text } from 'grommet';
import PropTypes from 'prop-types';

const ChatQuestionButton = ({ question, onClick, ...rest }) => (
  <Card
    pad="xsmall"
    onClick={onClick}
    hoverIndicator="background-contrast-hover"
    {...rest}
  >
    <Text size="small" weight="normal">
      {question}
    </Text>
  </Card>
);

ChatQuestionButton.propTypes = {
  question: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ChatQuestionButton;
